module.exports = __webpack_public_path__ + "static/illustration-earth-no-star--white-e3ef18aeedcd06c3021d82f178b920d8.svg";